import { ITransaction } from '../components/transaction';

export function isRefundable({ refundable }: ITransaction): boolean {
    return Boolean(process.env.REACT_APP_SHOW_DEV_TOOLS) && refundable;
}
